import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { UserService } from '@core/services';
import { User } from '@shared/models';


@Component({
  selector: 'app-update-mailing-address',
  templateUrl: './update-mailing-address.component.html',
  styleUrls: ['./update-mailing-address.component.css']
})
export class UpdateMailingAddressComponent implements OnInit, OnDestroy {
  public user: User;
  userSubscription: Subscription;

  constructor(private _userService: UserService) { }

  ngOnInit() {
    this.userSubscription = this._userService.getUser().subscribe(
      user => {
        this.user = user;
      }
    );
  }

  ngOnDestroy(){
    this.userSubscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/update-mailing-address/update-mailing-address.component.ts